class FixedTopRightElement {
  constructor() {
    this.$ = (css, parent = document) => parent.querySelector(css);
    this.header = null;
    this.fixedTopRight = null;
    this.scrollTimeout = null;

    this.init();
  }

  init() {
    this.initHeaderObserver();
  }

  initHeaderObserver() {
    this.header = this.$('header');
    this.fixedTopRight = this.$('.fixed-topright-element');

    if (!this.header || !this.fixedTopRight) {
      return;
    }

    const updateVisibility = () => {
      const hasRolodex = !!document.querySelector('.rolodex-hero');
      const isHeaderVisible = this.isElementVisible(this.header);
      // const scrolledPast64 = window.scrollY >= 64;
      // const isWideScreen = window.innerWidth >= 1024;

      const shouldAdjust = hasRolodex && !isHeaderVisible;

      this.fixedTopRight.classList.toggle(
        'fixed-topright-element--adjust',
        shouldAdjust
      );
    };

    updateVisibility();

    window.addEventListener('scroll', () => {
      if (this.scrollTimeout) clearTimeout(this.scrollTimeout);
      this.scrollTimeout = setTimeout(updateVisibility, 10);
    });
  }

  isElementVisible(element) {
    const style = window.getComputedStyle(element);
    return style.opacity !== '0';
  }
}

let fixedTopRightInstance = null;

function initializeFixedTopRight() {
  if (fixedTopRightInstance) {
    return;
  }

  fixedTopRightInstance = new FixedTopRightElement();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeFixedTopRight);
} else {
  initializeFixedTopRight();
}

